import { Tab, TabList, TabProvider } from '@ariakit/react'
import { useSubgeoStore } from '@/features/subgeo/store/subgeo-store'
import { useTranslation } from '@/translations/i18n'

const SUBGEOS_TAB_ID = 'subgeos'
const NEIGHBORHOODS_TAB_ID = 'neighborhoods'

export const SidebarTabs = () => {
	const { t } = useTranslation()
	const { activeTab, setActiveTab } = useSubgeoStore()

	return (
		<TabProvider
			selectedId={activeTab}
			setSelectedId={(id) =>
				setActiveTab(id as 'subgeos' | 'neighborhoods')
			}
		>
			<TabList className='flex w-full gap-0 rounded-t-xl border-neutral-200 border-b bg-neutral-white px-2.5 pt-1.5'>
				<Tab
					className='relative -bottom-px cursor-pointer border-0 border-transparent border-b-2 bg-transparent px-2 py-1.5 font-semibold text-neutral-500 text-sm transition-colors hover:text-blue-600 data-[active-item]:border-blue-600 data-[active-item]:text-blue-600'
					id={SUBGEOS_TAB_ID}
				>
					{t('subgeo:subgeos')}
				</Tab>
				<Tab
					className='relative -bottom-px cursor-pointer border-0 border-transparent border-b-2 bg-transparent px-2 py-1.5 font-semibold text-neutral-500 text-sm transition-colors hover:text-blue-600 data-[active-item]:border-blue-600 data-[active-item]:text-blue-600'
					id={NEIGHBORHOODS_TAB_ID}
				>
					{t('subgeo:neighborhoods')}
				</Tab>
			</TabList>
		</TabProvider>
	)
}
